/** Module picker / org sign-in hub (formerly `/login`). */
export const MODULE_HUB_PATH = '/';

/** Legacy URL — redirect to {@link MODULE_HUB_PATH}. */
export const LEGACY_MODULE_HUB_PATH = '/login';

/** Org self-service registration. */
export const REGISTER_PATH = '/register';

/** Per-product sign-in picker (POS, CRM, etc.). */
export const CHOOSE_APP_PATH = '/choose-app';

/** Legacy org signup URL — redirect to {@link REGISTER_PATH}. */
export const LEGACY_REGISTER_PATH = '/register';
